import _toConsumableArray from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { isContinuousFieldOrDatumDef, isFieldOrDatumDef, title } from '../channeldef';
import { extractTransformsFromEncoding, normalizeEncoding } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
import { replaceAll, titleCase } from '../util';
import { CompositeMarkNormalizer } from './base';
import { compositeMarkContinuousAxis, compositeMarkOrient, getCompositeMarkTooltip, makeCompositeAggregatePartFactory } from './common';
export var ERRORBAR = 'errorbar';
export var ERRORBAR_PARTS = ['ticks', 'rule'];
export var errorBarNormalizer = new CompositeMarkNormalizer(ERRORBAR, normalizeErrorBar);
export function normalizeErrorBar(spec, _ref) {
  var config = _ref.config;
  // Need to initEncoding first so we can infer type
  spec = Object.assign(Object.assign({}, spec), {
    encoding: normalizeEncoding(spec.encoding, config)
  });

  var _errorBarParams = errorBarParams(spec, ERRORBAR, config),
      transform = _errorBarParams.transform,
      continuousAxisChannelDef = _errorBarParams.continuousAxisChannelDef,
      continuousAxis = _errorBarParams.continuousAxis,
      encodingWithoutContinuousAxis = _errorBarParams.encodingWithoutContinuousAxis,
      ticksOrient = _errorBarParams.ticksOrient,
      markDef = _errorBarParams.markDef,
      outerSpec = _errorBarParams.outerSpec,
      tooltipEncoding = _errorBarParams.tooltipEncoding;

  delete encodingWithoutContinuousAxis['size'];
  var makeErrorBarPart = makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorbar);
  var thickness = markDef.thickness;
  var size = markDef.size;
  var tick = Object.assign(Object.assign({
    type: 'tick',
    orient: ticksOrient,
    aria: false
  }, thickness !== undefined ? {
    thickness: thickness
  } : {}), size !== undefined ? {
    size: size
  } : {});
  var layer = [].concat(_toConsumableArray(makeErrorBarPart({
    partName: 'ticks',
    mark: tick,
    positionPrefix: 'lower',
    extraEncoding: tooltipEncoding
  })), _toConsumableArray(makeErrorBarPart({
    partName: 'ticks',
    mark: tick,
    positionPrefix: 'upper',
    extraEncoding: tooltipEncoding
  })), _toConsumableArray(makeErrorBarPart({
    partName: 'rule',
    mark: Object.assign({
      type: 'rule',
      ariaRoleDescription: 'errorbar'
    }, thickness !== undefined ? {
      size: thickness
    } : {}),
    positionPrefix: 'lower',
    endPositionPrefix: 'upper',
    extraEncoding: tooltipEncoding
  })));
  return Object.assign(Object.assign(Object.assign({}, outerSpec), {
    transform: transform
  }), layer.length > 1 ? {
    layer: layer
  } : Object.assign({}, layer[0]));
}

function errorBarOrientAndInputType(spec, compositeMark) {
  var encoding = spec.encoding;

  if (errorBarIsInputTypeRaw(encoding)) {
    return {
      orient: compositeMarkOrient(spec, compositeMark),
      inputType: 'raw'
    };
  }

  var isTypeAggregatedUpperLower = errorBarIsInputTypeAggregatedUpperLower(encoding);
  var isTypeAggregatedError = errorBarIsInputTypeAggregatedError(encoding);
  var x = encoding.x;
  var y = encoding.y;

  if (isTypeAggregatedUpperLower) {
    // type is aggregated-upper-lower
    if (isTypeAggregatedError) {
      throw new Error("".concat(compositeMark, " cannot be both type aggregated-upper-lower and aggregated-error"));
    }

    var x2 = encoding.x2;
    var y2 = encoding.y2;

    if (isFieldOrDatumDef(x2) && isFieldOrDatumDef(y2)) {
      // having both x, x2 and y, y2
      throw new Error("".concat(compositeMark, " cannot have both x2 and y2"));
    } else if (isFieldOrDatumDef(x2)) {
      if (isContinuousFieldOrDatumDef(x)) {
        // having x, x2 quantitative and field y, y2 are not specified
        return {
          orient: 'horizontal',
          inputType: 'aggregated-upper-lower'
        };
      } else {
        // having x, x2 that are not both quantitative
        throw new Error("Both x and x2 have to be quantitative in ".concat(compositeMark));
      }
    } else if (isFieldOrDatumDef(y2)) {
      // y2 is a FieldDef
      if (isContinuousFieldOrDatumDef(y)) {
        // having y, y2 quantitative and field x, x2 are not specified
        return {
          orient: 'vertical',
          inputType: 'aggregated-upper-lower'
        };
      } else {
        // having y, y2 that are not both quantitative
        throw new Error("Both y and y2 have to be quantitative in ".concat(compositeMark));
      }
    }

    throw new Error('No ranged axis');
  } else {
    // type is aggregated-error
    var xError = encoding.xError;
    var xError2 = encoding.xError2;
    var yError = encoding.yError;
    var yError2 = encoding.yError2;

    if (isFieldOrDatumDef(xError2) && !isFieldOrDatumDef(xError)) {
      // having xError2 without xError
      throw new Error("".concat(compositeMark, " cannot have xError2 without xError"));
    }

    if (isFieldOrDatumDef(yError2) && !isFieldOrDatumDef(yError)) {
      // having yError2 without yError
      throw new Error("".concat(compositeMark, " cannot have yError2 without yError"));
    }

    if (isFieldOrDatumDef(xError) && isFieldOrDatumDef(yError)) {
      // having both xError and yError
      throw new Error("".concat(compositeMark, " cannot have both xError and yError with both are quantiative"));
    } else if (isFieldOrDatumDef(xError)) {
      if (isContinuousFieldOrDatumDef(x)) {
        // having x and xError that are all quantitative
        return {
          orient: 'horizontal',
          inputType: 'aggregated-error'
        };
      } else {
        // having x, xError, and xError2 that are not all quantitative
        throw new Error('All x, xError, and xError2 (if exist) have to be quantitative');
      }
    } else if (isFieldOrDatumDef(yError)) {
      if (isContinuousFieldOrDatumDef(y)) {
        // having y and yError that are all quantitative
        return {
          orient: 'vertical',
          inputType: 'aggregated-error'
        };
      } else {
        // having y, yError, and yError2 that are not all quantitative
        throw new Error('All y, yError, and yError2 (if exist) have to be quantitative');
      }
    }

    throw new Error('No ranged axis');
  }
}

function errorBarIsInputTypeRaw(encoding) {
  return (isFieldOrDatumDef(encoding.x) || isFieldOrDatumDef(encoding.y)) && !isFieldOrDatumDef(encoding.x2) && !isFieldOrDatumDef(encoding.y2) && !isFieldOrDatumDef(encoding.xError) && !isFieldOrDatumDef(encoding.xError2) && !isFieldOrDatumDef(encoding.yError) && !isFieldOrDatumDef(encoding.yError2);
}

function errorBarIsInputTypeAggregatedUpperLower(encoding) {
  return isFieldOrDatumDef(encoding.x2) || isFieldOrDatumDef(encoding.y2);
}

function errorBarIsInputTypeAggregatedError(encoding) {
  return isFieldOrDatumDef(encoding.xError) || isFieldOrDatumDef(encoding.xError2) || isFieldOrDatumDef(encoding.yError) || isFieldOrDatumDef(encoding.yError2);
}

export function errorBarParams(spec, compositeMark, config) {
  var _a; // TODO: use selection


  var mark = spec.mark,
      encoding = spec.encoding,
      params = spec.params,
      _p = spec.projection,
      outerSpec = __rest(spec, ["mark", "encoding", "params", "projection"]);

  var markDef = isMarkDef(mark) ? mark : {
    type: mark
  }; // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support

  if (params) {
    log.warn(log.message.selectionNotSupported(compositeMark));
  }

  var _errorBarOrientAndInp = errorBarOrientAndInputType(spec, compositeMark),
      orient = _errorBarOrientAndInp.orient,
      inputType = _errorBarOrientAndInp.inputType;

  var _compositeMarkContinu = compositeMarkContinuousAxis(spec, orient, compositeMark),
      continuousAxisChannelDef = _compositeMarkContinu.continuousAxisChannelDef,
      continuousAxisChannelDef2 = _compositeMarkContinu.continuousAxisChannelDef2,
      continuousAxisChannelDefError = _compositeMarkContinu.continuousAxisChannelDefError,
      continuousAxisChannelDefError2 = _compositeMarkContinu.continuousAxisChannelDefError2,
      continuousAxis = _compositeMarkContinu.continuousAxis;

  var _errorBarAggregationA = errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config),
      errorBarSpecificAggregate = _errorBarAggregationA.errorBarSpecificAggregate,
      postAggregateCalculates = _errorBarAggregationA.postAggregateCalculates,
      tooltipSummary = _errorBarAggregationA.tooltipSummary,
      tooltipTitleWithFieldName = _errorBarAggregationA.tooltipTitleWithFieldName;

  var _b = encoding,
      _c = continuousAxis,
      oldContinuousAxisChannelDef = _b[_c],
      _d = continuousAxis === 'x' ? 'x2' : 'y2',
      oldContinuousAxisChannelDef2 = _b[_d],
      _e = continuousAxis === 'x' ? 'xError' : 'yError',
      oldContinuousAxisChannelDefError = _b[_e],
      _f = continuousAxis === 'x' ? 'xError2' : 'yError2',
      oldContinuousAxisChannelDefError2 = _b[_f],
      oldEncodingWithoutContinuousAxis = __rest(_b, [typeof _c === "symbol" ? _c : _c + "", typeof _d === "symbol" ? _d : _d + "", typeof _e === "symbol" ? _e : _e + "", typeof _f === "symbol" ? _f : _f + ""]);

  var _extractTransformsFro = extractTransformsFromEncoding(oldEncodingWithoutContinuousAxis, config),
      bins = _extractTransformsFro.bins,
      timeUnits = _extractTransformsFro.timeUnits,
      oldAggregate = _extractTransformsFro.aggregate,
      oldGroupBy = _extractTransformsFro.groupby,
      encodingWithoutContinuousAxis = _extractTransformsFro.encoding;

  var aggregate = [].concat(_toConsumableArray(oldAggregate), _toConsumableArray(errorBarSpecificAggregate));
  var groupby = inputType !== 'raw' ? [] : oldGroupBy;
  var tooltipEncoding = getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis, tooltipTitleWithFieldName);
  return {
    transform: [].concat(_toConsumableArray((_a = outerSpec.transform) !== null && _a !== void 0 ? _a : []), _toConsumableArray(bins), _toConsumableArray(timeUnits), _toConsumableArray(aggregate.length === 0 ? [] : [{
      aggregate: aggregate,
      groupby: groupby
    }]), _toConsumableArray(postAggregateCalculates)),
    groupby: groupby,
    continuousAxisChannelDef: continuousAxisChannelDef,
    continuousAxis: continuousAxis,
    encodingWithoutContinuousAxis: encodingWithoutContinuousAxis,
    ticksOrient: orient === 'vertical' ? 'horizontal' : 'vertical',
    markDef: markDef,
    outerSpec: outerSpec,
    tooltipEncoding: tooltipEncoding
  };
}

function errorBarAggregationAndCalculation(markDef, continuousAxisChannelDef, continuousAxisChannelDef2, continuousAxisChannelDefError, continuousAxisChannelDefError2, inputType, compositeMark, config) {
  var errorBarSpecificAggregate = [];
  var postAggregateCalculates = [];
  var continuousFieldName = continuousAxisChannelDef.field;
  var tooltipSummary;
  var tooltipTitleWithFieldName = false;

  if (inputType === 'raw') {
    var center = markDef.center ? markDef.center : markDef.extent ? markDef.extent === 'iqr' ? 'median' : 'mean' : config.errorbar.center;
    var extent = markDef.extent ? markDef.extent : center === 'mean' ? 'stderr' : 'iqr';

    if (center === 'median' !== (extent === 'iqr')) {
      log.warn(log.message.errorBarCenterIsUsedWithWrongExtent(center, extent, compositeMark));
    }

    if (extent === 'stderr' || extent === 'stdev') {
      errorBarSpecificAggregate = [{
        op: extent,
        field: continuousFieldName,
        as: "extent_".concat(continuousFieldName)
      }, {
        op: center,
        field: continuousFieldName,
        as: "center_".concat(continuousFieldName)
      }];
      postAggregateCalculates = [{
        calculate: "datum[\"center_".concat(continuousFieldName, "\"] + datum[\"extent_").concat(continuousFieldName, "\"]"),
        as: "upper_".concat(continuousFieldName)
      }, {
        calculate: "datum[\"center_".concat(continuousFieldName, "\"] - datum[\"extent_").concat(continuousFieldName, "\"]"),
        as: "lower_".concat(continuousFieldName)
      }];
      tooltipSummary = [{
        fieldPrefix: 'center_',
        titlePrefix: titleCase(center)
      }, {
        fieldPrefix: 'upper_',
        titlePrefix: getTitlePrefix(center, extent, '+')
      }, {
        fieldPrefix: 'lower_',
        titlePrefix: getTitlePrefix(center, extent, '-')
      }];
      tooltipTitleWithFieldName = true;
    } else {
      var centerOp;
      var lowerExtentOp;
      var upperExtentOp;

      if (extent === 'ci') {
        centerOp = 'mean';
        lowerExtentOp = 'ci0';
        upperExtentOp = 'ci1';
      } else {
        centerOp = 'median';
        lowerExtentOp = 'q1';
        upperExtentOp = 'q3';
      }

      errorBarSpecificAggregate = [{
        op: lowerExtentOp,
        field: continuousFieldName,
        as: "lower_".concat(continuousFieldName)
      }, {
        op: upperExtentOp,
        field: continuousFieldName,
        as: "upper_".concat(continuousFieldName)
      }, {
        op: centerOp,
        field: continuousFieldName,
        as: "center_".concat(continuousFieldName)
      }];
      tooltipSummary = [{
        fieldPrefix: 'upper_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: upperExtentOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }, {
        fieldPrefix: 'lower_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: lowerExtentOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }, {
        fieldPrefix: 'center_',
        titlePrefix: title({
          field: continuousFieldName,
          aggregate: centerOp,
          type: 'quantitative'
        }, config, {
          allowDisabling: false
        })
      }];
    }
  } else {
    if (markDef.center || markDef.extent) {
      log.warn(log.message.errorBarCenterAndExtentAreNotNeeded(markDef.center, markDef.extent));
    }

    if (inputType === 'aggregated-upper-lower') {
      tooltipSummary = [];
      postAggregateCalculates = [{
        calculate: "datum[\"".concat(continuousAxisChannelDef2.field, "\"]"),
        as: "upper_".concat(continuousFieldName)
      }, {
        calculate: "datum[\"".concat(continuousFieldName, "\"]"),
        as: "lower_".concat(continuousFieldName)
      }];
    } else if (inputType === 'aggregated-error') {
      tooltipSummary = [{
        fieldPrefix: '',
        titlePrefix: continuousFieldName
      }];
      postAggregateCalculates = [{
        calculate: "datum[\"".concat(continuousFieldName, "\"] + datum[\"").concat(continuousAxisChannelDefError.field, "\"]"),
        as: "upper_".concat(continuousFieldName)
      }];

      if (continuousAxisChannelDefError2) {
        postAggregateCalculates.push({
          calculate: "datum[\"".concat(continuousFieldName, "\"] + datum[\"").concat(continuousAxisChannelDefError2.field, "\"]"),
          as: "lower_".concat(continuousFieldName)
        });
      } else {
        postAggregateCalculates.push({
          calculate: "datum[\"".concat(continuousFieldName, "\"] - datum[\"").concat(continuousAxisChannelDefError.field, "\"]"),
          as: "lower_".concat(continuousFieldName)
        });
      }
    }

    var _iterator = _createForOfIteratorHelper(postAggregateCalculates),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var postAggregateCalculate = _step.value;
        tooltipSummary.push({
          fieldPrefix: postAggregateCalculate.as.substring(0, 6),
          titlePrefix: replaceAll(replaceAll(postAggregateCalculate.calculate, 'datum["', ''), '"]', '')
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return {
    postAggregateCalculates: postAggregateCalculates,
    errorBarSpecificAggregate: errorBarSpecificAggregate,
    tooltipSummary: tooltipSummary,
    tooltipTitleWithFieldName: tooltipTitleWithFieldName
  };
}

function getTitlePrefix(center, extent, operation) {
  return "".concat(titleCase(center), " ").concat(operation, " ").concat(extent);
}